const IGNORED_INPUT_NAMES = ['authenticity_token', '_method']

export function buildFormValueSnapshot (form) {
  const mapping = new Map()
  for (const elem of form.querySelectorAll('input')) {
    const input = elem
    if (IGNORED_INPUT_NAMES.includes(input.name)) { continue }
    switch (input.type) {
      case 'radio':
        if (!input.checked) { continue }
        break
    }
    if (mapping.has(input.name)) { continue }
    mapping.set(input.name, input.value)
  }
  for (const elem of form.querySelectorAll('textarea')) {
    const input = elem
    if (mapping.has(input.name)) { continue }
    mapping.set(input.name, input.value)
  }
  return mapping
}
function detectFormModification (confirmable) {
  const originalValues = confirmable.originalValues
  const currentValues = confirmable.currentValues
  // お仕事状況の「いま仕事の話を振っても大丈夫？」のように初期値無し
  // radioボタンではbuildFormValueSnapshotで差分が記録されないため
  if (originalValues.size !== currentValues.size) { return true }
  return Array.from(originalValues.keys()).some((key) => {
    return originalValues.get(key) !== currentValues.get(key)
  })
}
function requireConfirmation (list) {
  return list.some((confirmable) => {
    if (detectFormModification(confirmable)) {
      return true
    }
    return false
  })
}
let confirmableForms = []
const dialogHandler = (event) => {
  if (requireConfirmation(confirmableForms)) {
    const result = window.confirm('保存されていない変更があります。移動してよろしいですか？')
    event.returnValue = result
  }
}
function resetFormSnapshot (confirmable) {
  const snapshot = buildFormValueSnapshot(confirmable.element)
  confirmable.originalValues = snapshot
  confirmable.currentValues = snapshot
}
// 送信中に入力された内容まで保存済みにしないよう、保存された値を基準にして現在の入力と比較する。
function markAsSaved (confirmable, savedValues) {
  confirmable.originalValues = savedValues
  confirmable.currentValues = buildFormValueSnapshot(confirmable.element)
}
function findConfirmable (form) {
  return confirmableForms.find((confirmable) => confirmable.element === form)
}
const submittedValues = new WeakMap()
const snapshotSubmittedForm = (event) => {
  const confirmable = findConfirmable(event.target)
  if (confirmable) submittedValues.set(event.detail.formSubmission, buildFormValueSnapshot(confirmable.element))
}
// 肉ボタンなど別のフォームの送信では、編集中の入力を保存済みにしない。
const syncSubmittedForm = (event) => {
  if (!event.detail.success) { return }
  const confirmable = findConfirmable(event.target)
  const savedValues = submittedValues.get(event.detail.formSubmission)
  if (confirmable && savedValues) markAsSaved(confirmable, savedValues)
}
function isConfirmableForm (value) {
  return value !== undefined
}
export const ConfirmableEvent = {
  reset: 'confirmable:reset'
}
export function Confirmable (Base) {
  return class extends Base {
    initConfirmableForms (formIdList) {
      const newForms = formIdList.map((formId) => {
        const form = document.getElementById(formId)
        if (form === null) { return undefined }
        const snapshot = buildFormValueSnapshot(form)
        if (snapshot === undefined) { return undefined }
        const confirmable = {
          element: form,
          originalValues: snapshot,
          currentValues: snapshot
        }
        form.addEventListener('change', () => {
          confirmable.currentValues = buildFormValueSnapshot(form)
        })
        form.addEventListener(ConfirmableEvent.reset, (event) => {
          const savedValues = event.detail?.savedValues
          savedValues ? markAsSaved(confirmable, savedValues) : resetFormSnapshot(confirmable)
        })
        return confirmable
      }).filter(isConfirmableForm)
      this.confirmableForms = newForms
      confirmableForms = confirmableForms.concat(newForms)
      window.addEventListener('turbo:submit-start', snapshotSubmittedForm)
      window.addEventListener('turbo:submit-end', syncSubmittedForm)
      window.addEventListener('turbo:before-visit', dialogHandler)
      window.addEventListener('beforeunload', dialogHandler)
    }

    disconnect () {
      confirmableForms = confirmableForms.filter((form) => !this.confirmableForms.includes(form))
      if (confirmableForms.length !== 0) { return }
      window.removeEventListener('beforeunload', dialogHandler)
      window.removeEventListener('turbo:before-visit', dialogHandler)
      window.removeEventListener('turbo:submit-end', syncSubmittedForm)
      window.removeEventListener('turbo:submit-start', snapshotSubmittedForm)
    }
  }
}
